import compose from "./compose";
import slice from "./slice";

// Symbol -> String
const symbolDescription = compose(slice(7, -1), toString);

export default symbolDescription;
